export type TimezoneOption = {
  value: string;
  label: string;
};

/** IANA ids. Labels are the UI form `UTC±offset — City`. */
export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { value: 'UTC', label: 'UTC' },
  { value: 'Europe/London', label: 'UTC+00:00 — London' },
  { value: 'Europe/Kyiv', label: 'UTC+02:00 — Kyiv' },
  { value: 'Europe/Berlin', label: 'UTC+01:00 — Berlin' },
  { value: 'Europe/Paris', label: 'UTC+01:00 — Paris' },
  { value: 'America/New_York', label: 'UTC-05:00 — New York' },
  { value: 'America/Chicago', label: 'UTC-06:00 — Chicago' },
  { value: 'America/Denver', label: 'UTC-07:00 — Denver' },
  { value: 'America/Los_Angeles', label: 'UTC-08:00 — Los Angeles' },
  { value: 'Asia/Tokyo', label: 'UTC+09:00 — Tokyo' },
  { value: 'Asia/Shanghai', label: 'UTC+08:00 — Shanghai' },
  { value: 'Asia/Dubai', label: 'UTC+04:00 — Dubai' },
  { value: 'Australia/Sydney', label: 'UTC+10:00 — Sydney' },
];

export function timezoneOptionLabel(
  ianaId: string | null | undefined,
): string | undefined {
  if (!ianaId) return undefined;
  return (
    TIMEZONE_OPTIONS.find((option) => option.value === ianaId)?.label ?? ianaId
  );
}
